import React, { useEffect, useState } from "react";

// Super-simple realtime clock with no Tailwind and no useMemo
// Drops into any React app. Pure browser APIs.
export default function RealtimeClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const timeString = now.toLocaleTimeString(undefined, {
    timeZone: "America/New_York",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });



  const timeStyle = { 
    marginTop: 12,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 1,
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    backgroundColor: "black",
    color: "white",
    padding: "5px 10px",
    borderRadius: 8

  } ;
//   const dateStyle = { marginTop: 8, fontSize: 12, color: "#555" } ;

  return (
       <a style={timeStyle}>{timeString} (EST)</a>
  );
}
